import React, { useState } from "react";
import { Typography, Menu, MenuItem, Button } from "@mui/material";
import { CalendarRange, ChevronDown } from "lucide-react";

const dateRanges = [
  { label: "Last 7 Days", value: "7days" },
  { label: "Last 30 Days", value: "30days" },
  { label: "Last Quarter", value: "quarter" },
  { label: "Last Year", value: "year" },
  { label: "All Time", value: "all" },
];

const DashboardHeader = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRange, setSelectedRange] = useState(dateRanges[1]); // Default to Last 30 Days

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRangeSelect = range => {
    setSelectedRange(range);
    setAnchorEl(null);
  };

  return (
    <div className="bg-white border-b border-[#E5E7EB]">
      <div className="px-6 py-4">
        <div className="flex justify-between items-center">
          <Typography variant="h6" className="font-semibold text-[#374151]">
            Dashboard Overview
          </Typography>

          <Button
            onClick={handleClick}
            variant="outlined"
            size="small"
            className="normal-case"
            startIcon={<CalendarRange size={16} />}
            endIcon={<ChevronDown size={14} />}
            sx={{
              borderColor: "#E5E7EB",
              color: "#374151",
              fontFamily: "Outfit, sans-serif",
              fontSize: "0.75rem",
              fontWeight: 500,
              padding: "4px 12px",
              borderRadius: "6px",
              height: "32px",
              "&:hover": {
                borderColor: "#5652B0",
                backgroundColor: "rgba(86, 82, 176, 0.04)",
              },
            }}>
            {selectedRange.label}
          </Button>
        </div>
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 2,
          sx: {
            minWidth: 160,
            borderRadius: "8px",
            mt: 1,
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
          },
        }}>
        {dateRanges.map(range => (
          <MenuItem
            key={range.value}
            onClick={() => handleRangeSelect(range)}
            selected={selectedRange.value === range.value}
            sx={{
              fontFamily: "Outfit, sans-serif",
              fontSize: "0.75rem",
              paddingY: "6px",
              "&.Mui-selected": {
                backgroundColor: "rgba(86, 82, 176, 0.08)",
                "&:hover": {
                  backgroundColor: "rgba(86, 82, 176, 0.12)",
                },
              },
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}>
            {range.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default DashboardHeader;
